import * as CryptoJS from 'crypto-js';

const key = '9DPQ6K32LTYOFMFY'; // 16-byte key (128 bit)
const iv = 'DGXYFJ9LCKGYUABD'; // 16-byte IV

export function encrypt(plainText: string): string {

    const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

export function decrypt(cipherText: string): string {

    const bytes = CryptoJS.AES.decrypt(cipherText, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return bytes.toString(CryptoJS.enc.Utf8);
}
